<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="https://www.maika.coffee/owner">Maïka</a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <!-- <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="#">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Features</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Pricing</a>
          </li>
        </ul> -->
        <!-- IF NOT CONNECTED -->
        <ul class="navbar-nav ms-auto" v-if="isConnected == 'no'">
          <li class="nav-item">
            <button
              class="btn btn-primary top-bar-button"
              @click="tryApp"
              type="submit"
            >
              {{ $t("topbar.tryAppLabel") }}
            </button>
          </li>
          <li class="topbar-why-join-maik-link">
            <a target="_blank" :href="$t('topbar.whyJoinURL')">{{
              $t("topbar.whyJoinLabel")
            }}</a>
          </li>
          <!-- <h4>{{ $t("topbar.ownerTitle") }}</h4>
          <li class="nav-item">
            <button class="btn btn-primary top-bar-button" type="submit">
              {{ $t("topbar.addMyPlace") }}
            </button>
          </li>
          <li class="nav-item">
            <button
              class="btn btn-outline-primary top-bar-outline-button"
              type="submit"
              @click="$router.replace('login')"
            >
              {{ $t("topbar.loginSignup") }}
            </button>
          </li> -->
        </ul>
        <!-- IF CONNECTED -->
        <ul
          class="navbar-nav ms-auto navbar-dropdown-connected"
          v-if="isConnected == 'yes'"
        >
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ $t("topbar.welcome", { username: owner.firstname }) }}
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <li>
                <a class="dropdown-item" :href="'/owner'">{{
                  $t("topbar.myPlaces")
                }}</a>
              </li>
              <li>
                <a class="dropdown-item" :href="'/owner/account'">{{
                  $t("topbar.myAccount")
                }}</a>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click="logout">{{
                  $t("topbar.logout")
                }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import OwnerService from "@/services/OwnerService";
import router from "@/router";
import { IOS_URL, ANDROID_URL, QR_CODE_URL } from "@/const";

const ownerService = new OwnerService();

export default defineComponent({
  name: "Topbar",
  props: {
    isConnected: String,
    owner: Object,
  },
  setup(props) {
    console.log("PROPS", props);
  },
  methods: {
    // click on try the app button
    tryApp: async () => {
      // if android or iOS redirect to the stores
      // const androidDevices = ["Android"];
      // const iosDevices = ["iPhone", "iPad", "iPod"];

      const userDevice = navigator.userAgent;
      console.log("userDevice", userDevice);
      if (userDevice.includes("iPhone") || userDevice.includes("iPod")) {
        window.open(IOS_URL); // app store
      } else if (userDevice.includes("Android")) {
        window.open(ANDROID_URL); // android store
      } else {
        // if web, open window with qr code
        window.open(
          QR_CODE_URL,
          "mywindow",
          "menubar=1,resizable=1,width=350,height=250"
        );
      }
    },
    /**
     * Logout the connected user
     * remove items from LS
     * reload page
     */
    logout: async () => {
      ownerService.logoutOwner();
      window.location.reload();
    },
  },
});
</script>

<style></style>
